import { render, staticRenderFns } from "./detailsView.vue?vue&type=template&id=9f34396a&scoped=true&"
import script from "./detailsView.vue?vue&type=script&lang=js&"
export * from "./detailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f34396a",
  null
  
)

export default component.exports